import { gql } from '@apollo/client';
import * as map from './map';
import * as directories from './directories';
import * as planOwners from './planOwners';
import * as users from './users';
import * as plans from './plans';
import * as flux from './flux';
import * as generationTasks from './generationTasks';
import * as siteVisit from './siteVisit';
import * as mapSession from './mapSession';
import * as contractors from './contractors';
import * as project from './project';
import * as order from './order';
import * as proposal from './proposal';

export const FIND_CONFIGURATOR = gql`
  query Plans($decorId: String, $id: ID) {
    findConfigurator(decorId: $decorId, id: $id)
  }
`;

export const FIND_PHOTOS = gql`
  query Plans($decorId: String, $id: ID) {
    findPhotos(decorId: $decorId, id: $id)
  }
`;

export const TEMPLATES = gql`
  query Templates {
    templates {
      id
      title
      typeformId
      link
    }
  }
`;

export const TEMPLATE = gql`
  query Templates($id: ID!) {
    template(id: $id) {
      id
      title
      typeformId
      link
      specifications
    }
  }
`;

export const ASSISTANT_CHATS = gql`
  query AssistantChat {
    assistantChats {
      id
      email
      name
    }
  }
`;

export const ASSISTANT_CHAT = gql`
  query AssistantChat($id: ID!) {
    assistantChat(id: $id) {
      id
      email
      name
      messages
      plans
    }
  }
`;

export const GET_ALL_PRODUCTS_OF_CONFIGURATORS = gql`
  query ProductsOfConfigurators {
    productsOfConfigurators {
      list
    }
  }
`;

export {
  map,
  directories,
  planOwners,
  users,
  plans,
  flux,
  generationTasks,
  siteVisit,
  mapSession,
  contractors,
  project,
  order,
  proposal,
};
